import { appServices } from '../helpers/app-services/AppServices';
import { sendErrorToSentry } from '../../logging';

class AuthenticationProvider {
  validateCredentials = (email, password) => {
    return appServices.authenticate(email, password).then(res => {
      const { firstname, lastname, id, email, accountType, term, token, internalUser, userTokens } = res;
      const user = {
        id,
        firstname,
        lastname,
        email,
        accountType,
        term,
        internalUser
      };
      return { user, token, userTokens };
    });
  };

  validateToken = () => {
    return appServices.getUser().then(res => {
      const { firstname, lastname, id, email, accountType, term, token, internalUser } = res;
      const user = {
        id,
        firstname,
        lastname,
        email,
        accountType,
        term,
        internalUser
      };
      return { user, token };
    });
  };

  _getUserDetails = user => {
    return appServices.getAppData('userdetails', user).catch(err => {
      sendErrorToSentry(err); // Reports any `getAppData` error.
      return {}; // `Caller` expects an object back.
    });
  };

  _setUserDetails = userDetails => {
    return appServices.setAppData('userdetails', userDetails); // Promises resolves with `null`
  };
}

export default AuthenticationProvider;
export const authenticationProvider = new AuthenticationProvider();
